module.exports = __webpack_public_path__ + "img/index_pic27.a733d677.png";